export interface BiaState {
  allBias: any;
  bias: any;
  count: number;
  callTrees: any;
  vitalRecord: any;
  processes: any;
  impacts: any;
  itInfraRquire: any;
  splReq: any;
  inDependencies: any;
  exDependencies: any;
  peakTimes: any;
  deadLines: any;
  adInfo: any;
  appNSoft: any;
  hr: any;
  resourceCallTree: any;
  staffReq: any;
  spof: any;
  workflowActivity: any;
  biaIntro: any;
}

export const initialState: BiaState = {
  allBias: [],
  bias: [],
  count: 0,
  callTrees: {},
  vitalRecord: {},
  processes: {},
  impacts: {},
  itInfraRquire: {},
  splReq: {},
  inDependencies: {},
  exDependencies: {},
  peakTimes: {},
  deadLines: {},
  adInfo: {},
  appNSoft: {},
  hr: {},
  resourceCallTree: {},
  staffReq: {},
  spof: {},
  workflowActivity: {},
  biaIntro: {},
};
